import WebApp from '@twa-dev/sdk';
import { env } from './env';
import { IUser } from 'src/contexts/AppContext';

const { isProd, developers } = env;

declare global {
  interface Window {
    ym: any;
    initializedAt: Date;
    isLocalHost: boolean;
  }
}

export const exponentialDelay = (attempt: number, baseDelay = 1000, randomizationFactor = 0.2): number => {
  if (attempt === 0) return 0;

  // Calculate exponential delay starting from attempt 1
  const exponentialDelay = baseDelay * Math.pow(2, attempt - 1);

  // Add randomization (±20% of the exponential delay by default)
  const randomFactor = 1 - randomizationFactor + Math.random() * randomizationFactor * 2;
  const finalDelay = exponentialDelay * randomFactor;

  return Math.floor(finalDelay);
};

export const sleep = (ms: number): Promise<void> => {
  if (ms === 0) return Promise.resolve();
  console.debug(`Sleeping for ${ms / 1000}s`);
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const shouldBlockDesktop = () => {
  const isMobile = ['android', 'android_x', 'ios'].indexOf(WebApp.platform) >= 0;

  return !isMobile && isProd && !developers.includes(WebApp?.initDataUnsafe?.user?.id?.toString());
};

export const getTgUserId = () => {
  return WebApp.initDataUnsafe?.user?.id;
};

export const getInvitedBy = () => {
  if (!WebApp?.initDataUnsafe?.user || !WebApp?.initDataUnsafe?.start_param) return undefined;
  const startParam = Number(WebApp.initDataUnsafe.start_param);
  if (WebApp.initDataUnsafe.user.id === startParam) return undefined;
  return startParam;
};

export const handleResize = () => {
  const scale = document.documentElement.clientWidth > 1080 ? 1 : document.documentElement.clientWidth / 1080;
  document.documentElement.style.setProperty('--scale', scale.toString());
};

export const friendsLevels = [
  [1, 1],
  [2, 5],
  [3, 10],
  [4, 25],
  [5, 50],

  [6, 100],
  [7, 500],
  [8, 1000],
  [9, 5000],
  [10, 10000],

  [11, 20000],
  [12, 50000],
  [13, 100000],
  [14, 250000],
  [15, 500000],
];

export const getLevel = (user: IUser): number => {
  const total = user.friendsLevel1Count + user.friendsLevel2Count;

  return friendsLevels.reduce((acc, level, index) => (total > level[1] ? index : acc), 0);
};
